<template>
  <div>
    <br />
    <div class="d-flex justify-content-center">
      <span
        class="p-2 fs-5"
        :class="repair.validated ? 'text-success' : 'text-warning'"
      >
        <span v-if="repair.validated" class="fs-5">
          <i class="bi bi-check2"></i>
        </span>
        Réparation Nº :
        <span class="fw-bold fs-5">
          {{ $route.params.reference }}
        </span>

        <span class="fw-bold text-dark fs-5">
          {{ repair.date }}
        </span>
      </span>
    </div>
    <div class="d-flex justify-content-center align-items-center p-0">
      <div class="col-auto row">
        <div
          v-if="!repair.validated && userRole == 'Admin'"
          class="col-auto p-1"
        >
          <button
            @click="
              $router.push({
                name: 'repairs-validated',
                params: {
                  reference: repair.reference,
                },
              })
            "
            class="btn border text-success border-success"
          >
            <i class="bi bi-check2-square text-success fs-4"></i> Valider
          </button>
        </div>

        <div
          v-if="repair.reference && userRole == 'Admin'"
          class="col-auto p-1"
        >
          <button
            @click="
              $router.push({
                name: 'repairs-edit',
                params: { reference: repair.reference },
              })
            "
            class="btn border"
          >
            <i class="bi bi-pencil-square text-secondary fs-4"></i> Modifier
          </button>
        </div>

        <div
          v-if="repair.reference && userRole == 'Admin'"
          class="col-auto p-1"
        >
          <button
            @click="remove(repair.reference)"
            class="btn border border-danger text-danger"
          >
            <i class="bi bi-archive-fill text-danger fs-4"></i> Supprimer
          </button>
        </div>

        <div
          v-if="repair.reference"
          class="col-auto p-1"
        >
          <button
            @click="createInvoice(repair.reference)"
            class="btn border border-primary text-primary"
          >
            <i class="bi bi-printer text-primary fs-4"></i> Créer facture
          </button>
        </div>

        <div v-if="repair.reference" class="col-auto p-1">
          <button @click="print(repair.reference)" class="btn border">
            <i class="bi bi-printer text-secondary fs-4"></i> Imprimer BL
          </button>
        </div>

        <div v-if="repair.reference" class="col-auto p-1">
          <button
            @click="printRepairOrder(repair.reference)"
            class="btn border"
          >
            <i class="bi bi-printer text-secondary fs-4"></i>
            Ordre de réparation
          </button>
        </div>

        <div v-if="repair.reference" class="col-auto p-1">
          <button @click="createAppointment(repair)" class="btn border">
            <i class="bi bi-calendar-check text-secondary fs-4"></i>
            Créer RDV
          </button>
        </div>

        <div class="col-auto p-1">
          <button @click="refresh()" class="btn border">
            <i class="bi bi-arrow-clockwise text-secondary fs-4"></i> Actualiser
          </button>
        </div>
      </div>
    </div>
    <hr />
    <div class="row align-items-stretch" id="printMe">
      <div class="col-4">
        <div class="row justify-content-between">
          <div class="col p-1">Client</div>
          <div class="col p-1 fw-bold">
            <span
              v-if="repair.customer"
              :class="
                repair.customer.fullName.includes('Bloqué') ? 'text-danger' : ''
              "
            >
              {{ repair.customer.fullName }}
            </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Nº de Téléphone</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer">
              {{ repair.customer.phone }}
            </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Nom Commercial (Société)</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer">
              {{ repair.customer.society }}
            </span>
          </div>
        </div>
      </div>
      <!-- ***** -->
      <div class="col-4 justify-content-between">
        <div class="row">
          <div class="col p-1">Quantité totale</div>
          <div v-if="repair.totalQuantity" class="col p-1 fw-bold">
            {{ repair.totalQuantity }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Montant Total TTC</div>
          <div v-if="repair.totalPriceTTC" class="col p-1 fw-bold">
            {{ repair.totalPriceTTC | toFixedWithSpace }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Montant Total HT</div>
          <div v-if="repair.totalPriceHT" class="col p-1 fw-bold">
            {{ repair.totalPriceHT | toFixedWithSpace }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Montant Total TVA</div>
          <div v-if="repair.totalPriceTVA" class="col p-1 fw-bold">
            {{ repair.totalPriceTVA | toFixedWithSpace }}
          </div>
        </div>
      </div>
      <!-- paiments -->
      <div class="col-4 justify-content-between">
        <div class="row">
          <div class="col p-1">Total Payé :</div>
          <div v-if="repair.amountPaid" class="col p-1 fw-bold">
            {{ repair.amountPaid | toFixedWithSpace }}
          </div>
          <div v-else class="col p-1 fw-bold text-danger">----------</div>
        </div>

        <div class="row">
          <div class="col p-1">Montant Impayé :</div>
          <div v-if="repair.amountUnpaid" class="col p-1 fw-bold">
            {{ repair.amountUnpaid | toFixedWithSpace }}
          </div>
        </div>

        <div class="row">
          <div class="col p-1">Échéance :</div>
          <div class="col p-1 fw-bold">
            {{ repair.deadline }}
          </div>
        </div>
      </div>
    </div>

    <br />
    <div class="row align-items-stretch">
      <div class="col-4">
        <div class="row justify-content-between">
          <div class="col p-1">État de livraison</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Livré par :</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Livré le :</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer"> - </span>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="row justify-content-between">
          <div class="col p-1">Vérifié (oui/non) :</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Vérifié par :</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Vérifié à :</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer"> - </span>
          </div>
        </div>
      </div>

      <div class="col-4">
        <div class="row justify-content-between">
          <div class="col p-1">Validé (oui/non) :</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.validated"> Validée </span>
            <span v-else class="bg-warning rounded p-1"> En Attente </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Validé par :</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer"> - </span>
          </div>
        </div>

        <div class="row justify-content-between">
          <div class="col p-1">Validé à :</div>
          <div class="col p-1 fw-bold">
            <span v-if="repair.customer"> - </span>
          </div>
        </div>
      </div>
    </div>
    <br />
    <div class="row">
      <div class="col-2">Remarque :</div>
      <div class="col fw-bold">
        {{ repair.remark }}
      </div>
    </div>

    <br />
    <div class="text-uppercase">Photos</div>
    <div class="row align-items-stratch">
      <div
        v-for="(photo, index) in repair.repair_photos"
        :key="index++"
        class="col-xl-3 my-2"
      >
        <img :src="photo.path" alt="" class="w-100" />
      </div>
    </div>
    <br />
    <div class="text-uppercase">Entretiens Effectués</div>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Référence</th>
          <th scope="col">Nom</th>
          <th scope="col">Quantité</th>
          <th scope="col">Prix U (TTC)</th>
          <th scope="col">M. Total</th>
          <th scope="col">Remarque</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(service, index) in repair.repair_services" :key="index++">
          <td>
            {{ index }}
          </td>
          <td>
            {{ service.service_reference }}
          </td>
          <td>
            <span v-if="service.service">
              {{ service.service.fullName }}
            </span>
          </td>
          <td>{{ service.quantity }}</td>
          <td class="fw-bold">
            {{ service.priceTTC | toFixedWithSpace }}
          </td>
          <td class="fw-bold">
            {{ service.totalPriceTTC | toFixedWithSpace }}
          </td>

          <td>
            {{ service.remark }}
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div class="text-uppercase">PIÈCES DE KITS DE RÉPARATIONs</div>

    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col">Référence</th>
          <th scope="col">Nom</th>
          <th scope="col">Quantité</th>
          <th scope="col">Prix U (TTC)</th>
          <th scope="col">M. Total</th>
          <th scope="col">Stock</th>
          <th scope="col">Remarque</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in repair.repair_items" :key="index++">
          <td>
            {{ index }}
          </td>
          <td>
            {{ item.item_reference }}
          </td>
          <td>
            <span v-if="item.item">
              {{ item.item.fullName }}
            </span>
          </td>
          <td>{{ item.quantity }}</td>
          <td class="fw-bold">
            {{ item.priceTTC | toFixedWithSpace }}
          </td>
          <td class="fw-bold">
            {{ item.totalPriceTTC | toFixedWithSpace }}
          </td>

          <td>
            <span v-if="item.stock">
              {{ item.stock.fullName }}
            </span>
          </td>

          <td>
            {{ item.remark }}
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <div class="text-uppercase">Paiments</div>

    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th scope="col-1">Nº</th>
          <th scope="col-2">Référence</th>
          <th scope="col-2">Date</th>
          <th scope="col-2">Mode</th>
          <th scope="col-2">M. Payé</th>
          <th scope="col-2">M. à Régler</th>
          <th scope="col-2">Créer par</th>
          <th scope="col">Remarque</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(payment, index) in repair.payments" :key="index++">
          <td>
            {{ index }}
          </td>
          <td>
            {{ payment.reference }}
          </td>

          <td>{{ payment.date }}</td>

          <td class="text-warning">
            <span>
              {{ payment.paymentMethod }}
            </span>
          </td>
          <td class="text-success">
            <span v-if="payment.amount >= 0">
              {{ payment.amount | toFixedWithSpace }}
            </span>
          </td>
          <td class="text-danger">
            <span v-if="payment.remainingAmount >= 0">
              {{ payment.remainingAmount | toFixedWithSpace }}
            </span>
          </td>
          <td>
            <span v-if="payment.user">
              {{ payment.user.name }}
            </span>
          </td>
          <td>
            <span>
              {{ payment.remark }}
            </span>
          </td>
          <td class="p-0 m-0">
            <button
              @click="
                $router.push({
                  name: 'payments-details',
                  params: { reference: payment.reference },
                })
              "
              class="btn"
            >
              <i class="bi bi-info-square fs-5"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  data() {
    return {};
  },

  mounted() {
    this.$store.dispatch("repair/show", this.$route.params.reference);
  },
  computed: {
    ...mapGetters("repair", {
      repair: "getRepair",
    }),
    ...mapGetters("auth", {
      userRole: "getUserRole",
    }),
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("repair/show", this.$route.params.reference);
    },

    async print(reference) {
      this.$store.dispatch("repair/print", reference);
    },
    async printRepairOrder(reference) {
      this.$store.dispatch("repair/printRepairOrder", reference);
    },
    async createInvoice(reference) {
      await this.$store.dispatch("invoice/store", {
        repair_reference: reference,
      });
    },
    async createAppointment(repair) {
      this.$router.push({
        name: "appointments-create",
        query: {
          repair_reference: repair.reference,
          customer_reference: repair.customer_reference,
        },
      });
    },
    async remove(reference) {
      let data = reference;
      await this.$confirm({
        message: "Vous voulez supprimer la facture  " + data,
        button: {
          no: "Non",
          yes: "Oui",
        },

        callback: (confirm) => {
          if (confirm) {
            this.$store.dispatch("repair/destroy", data);
          }
        },
      });
    },
  },
  filters: {
    toFixedWithSpace: (value) => {
      return parseFloat(value)
        .toFixed(2)
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ");
    },
  },
};
</script>
